var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paging" }, [
    _c("div", { staticClass: "paging__count" }, [
      _vm._v(
        "\n    Viewing " +
          _vm._s(_vm.currentVisibleItemsCount) +
          " - " +
          _vm._s(_vm.totalItemsCount) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _vm.currentPage + 1 < _vm.totalPages
      ? _c(
          "button",
          {
            staticClass: "c-btn c-btn--padding-slim c-btn--alpha c-btn--ghost",
            on: {
              click: function($event) {
                return _vm.buttonClick(true)
              }
            }
          },
          [_vm._v("\n    View more\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }